import { render, staticRenderFns } from "./properties-block-slideshow.vue?vue&type=template&id=c10fdf24&scoped=true"
import script from "./properties-block-slideshow.vue?vue&type=script&lang=js"
export * from "./properties-block-slideshow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10fdf24",
  null
  
)

export default component.exports